import { render } from "./SmsNotification.vue?vue&type=template&id=1ec3194e"
import script from "./SmsNotification.vue?vue&type=script&lang=js"
export * from "./SmsNotification.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__